import { APP_TYPES } from '@config';
import Scene from '@scene';
import ObjectView from '@scene/views/object-view';

export const RESET_CAMERA = 'RESET_CAMERA';
export const SET_AXIS_POSITION = 'SET_AXIS_POSITION';
export const SET_AXIS_ORIENTATION = 'SET_AXIS_ORIENTATION';
export const SET_CAMERA_STATE = 'SET_CAMERA_STATE';
export const RESET_CAMERA_STATE = 'RESET_CAMERA_STATE';
export const SET_PERSPECTIVE_CAMERA = 'SET_PERSPECTIVE_CAMERA';
export const SET_PERSPECTIVE_CAMERA_TYPE = 'SET_PERSPECTIVE_CAMERA_TYPE';

export const PerspectiveCameraTypes = {
  zoom_out: 'zoom_out',
  focus_base_plate: 'focus_base_plate'
};

/*
  Action creators
 */
export function resetCamera (appType) {
  return (dispatch, getState) => {
    dispatch({ type: RESET_CAMERA, appType, mode: getState().main.mode });
    Scene.updateCamera(getState().camera);
  };
}
export function setAxisPosition (position) {
  return (dispatch, getState) => {
    dispatch({ type: SET_AXIS_POSITION, position });

    Scene.updateAxis(getState().camera.axis);
  };
}

export function setAxisOrientation (orientation) {
  return (dispatch, getState) => {
    dispatch({ type: SET_AXIS_ORIENTATION, orientation });

    Scene.updateCamera(getState().camera);
    Scene.updateAxisOrientation(getState().main.mode === ObjectView.mode.MODE_3D ? 
      getState().camera.axis.orientation3D : getState().camera.axis.orientation2D);
    setTimeout(() => Scene.resetCamera());
  };
}

export function setCameraState(state) {
  return { type: SET_CAMERA_STATE, state };
}

export function resetCameraState() {
  return { type: RESET_CAMERA_STATE };
}

export function setPerspectiveCamera(options) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERSPECTIVE_CAMERA, options});
    
    Scene.updateCamera(getState().camera);
  };
}

export function setPerspectiveCameraType(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERSPECTIVE_CAMERA_TYPE, value});
    if (getState().main.appType === APP_TYPES.SAFETY_BARRIER) {
      if (value === PerspectiveCameraTypes.zoom_out) {
        dispatch(setPerspectiveCamera(getState().selectors.application[APP_TYPES.SAFETY_BARRIER].selectedSubtype.config.perspectiveCamera));
      } else if (value === PerspectiveCameraTypes.focus_base_plate) {
        dispatch(setPerspectiveCamera(getState().selectors.application[APP_TYPES.SAFETY_BARRIER].selectedSubtype.config.basePlateCamera));
      }
      setTimeout(() => Scene.resetCamera());
    }
  };
}



// WEBPACK FOOTER //
// ./src/reducers/camera/actions.js